import React from "react";
import { Divider as AntDivider } from "antd";
import "./style.scss";

const Divider = ({
  type = "horizontal",
  color = "#EBE9EB",
  bgColor,
  className,
  height,
  width,
  circle,
}) => {
  return (
    <AntDivider
      className={`default-divider ${className ? className : ""} ${circle ? "circle-divider" : ""} `}
      style={{
        borderColor: color,
        backgroundColor: bgColor,
        height: height,
        width: width,
      }}
      type={type}
    />
  );
};

export default Divider;
